module.exports = __webpack_public_path__ + "static/media/400056_01.2028caad.png";